import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Container, Row, Col } from "react-bootstrap";
import CommonStructured from "../../components/common-components/CommonStructured";
import HelmetWrapper from "../../HelmetWrapper";
import { selectUser } from "../../components/auth/auth.selector";
import {
  fetchCentralisedPlansData,
  fetchAllAddonDraftsData,
} from "../../redux/plans-reducers/plansSlice";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import CentralisedTabs from "../../components/centralised-plan-system/centralised-beta/CentralisedTabs";
import DetailListings from "../../components/centralised-plan-system/details/DetailListings";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import AddFeature from "../../components/centralised-plan-system/AddFeature";
import CentralisedForm from "../../components/centralised-plan-system/centralised-beta/CentralisedForm";
import CPMapForm from "../../components/centralised-plan-system/centralised-beta/CPMapForm";
import MappedGyms from "../../components/centralised-plan-system/centralised-beta/MappedGyms";
import CentralisedPTForm from "../../components/centralised-plan-system/centralised-beta/pt/CentralisedPTForm";

const CentralisedPlans = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const { centralisedPlansLoading } = useSelector((state) => state.plans);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: "",
    selectedPlanDuration: "",
    selectedCouplePlan: "",
    selectedAllAccessPlan: "",
    selectedGymCategory: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    couple_included: allFilters.selectedCouplePlan?.value || "",
    plan_duration: allFilters.selectedPlanDuration?.value || "",
    is_allgym_access: allFilters.selectedAllAccessPlan?.value || "",
    category_id: allFilters.selectedGymCategory?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
    isPT: false,
  };
  const [modValues, setModValues] = useState(iniModValues);
  const [selectedTab, setSelectedTab] = useState(0);

  function getAllCentralisedPlans(filters) {
    dispatch(
      fetchCentralisedPlansData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getAllAddonDrafts(filters) {
    dispatch(
      fetchAllAddonDraftsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, name: allFilters.searchString }));
    }
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  useEffect(() => {
    getAllCentralisedPlans(filters);
  }, [filters]);

  useEffect(() => {
    getAllAddonDrafts(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      couple_included: allFilters.selectedCouplePlan?.value || "",
      plan_duration: allFilters.selectedPlanDuration?.value || "",
      is_allgym_access: allFilters.selectedAllAccessPlan?.value || "",
      category_id: allFilters.selectedGymCategory?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedGymCategory,
    allFilters.selectedCouplePlan,
    allFilters.selectedPlanDuration,
    allFilters.selectedAllAccessPlan,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, name: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Centralised Plan Management">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}>
          {modValues.modName === "plan_features" ? (
            <div className={"modal-body-k bg-white rounded-5 autoHeightMax"}>
              <AddFeature
                onCloseModal={onCloseModal}
                rowData={modValues.rowData}
              />
            </div>
          ) : (
            <div
              className={`createNewCTOModalContainer ${
                modValues.modName === "view_details" && !modValues.isPT
                  ? "mod-width-50p"
                  : ""
              }`}>
              {modValues.modName !== "add-regular" &&
                modValues.modName !== "add-pt" &&
                modValues.modName !== "edit" &&
                modValues.modName !== "map_plans" && (
                  <ModalHeadAndClose
                    title={
                      modValues.modName === "view_details"
                        ? modValues.isPT
                          ? `${modValues.rowData?.addon_name || ""}`
                          : `${modValues.rowData?.plan_name || ""}/${
                              modValues.rowData?.duration || 0
                            } Days`
                        : modValues.modName === "edit" ||
                          modValues.modName === "mapped_gyms"
                        ? `${modValues.rowData?.plan_name || ""}/${
                            modValues.rowData?.duration || 0
                          } Days`
                        : modValues.modName === "add"
                        ? " "
                        : modValues.modName?.replace(/_/g, " ")
                    }
                    onClose={onCloseModal}
                  />
                )}

              {modValues.modName === "view_details" ? (
                <DetailListings row={modValues.rowData} isPT={modValues.isPT} />
              ) : modValues.modName === "add-regular" ||
                modValues.modName === "edit" ? (
                <CentralisedForm
                  userInfoData={userInfoData}
                  rowData={modValues.rowData}
                  isEdit={modValues.modName === "edit"}
                  closeModal={onCloseModal}
                  callFunction={() => getAllCentralisedPlans(filters)}
                />
              ) : modValues.modName === "add-pt" ? (
                <CentralisedPTForm
                  userInfoData={userInfoData}
                  rowData={modValues.rowData}
                  isEdit={modValues.modName === "edit"}
                  closeModal={onCloseModal}
                  callFunction={() => getAllCentralisedPlans(filters)}
                />
              ) : modValues.modName === "map_plans" ? (
                <CPMapForm
                  userInfoData={userInfoData}
                  rowData={modValues.rowData}
                  closeModal={onCloseModal}
                  callFunction={() => getAllCentralisedPlans(filters)}
                />
              ) : modValues.modName === "mapped_gyms" ? (
                <MappedGyms
                  userInfoData={userInfoData}
                  rowData={modValues.rowData}
                  callFunction={() => getAllCentralisedPlans(filters)}
                />
              ) : null}
            </div>
          )}
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Centralised Plan Management"}
              isReload={() => {
                getAllCentralisedPlans(filters);
                getAllAddonDrafts(filters);
              }}
              createBtnTxt={"+ Add New Regular Plan"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add-regular",
                  isPT: false,
                }))
              }
              // createBtnTxt2={"+ Add New PT Plan"}
              // onClickCreateBtn2={() =>
              //   setModValues((prevs) => ({
              //     ...prevs,
              //     isModOpen: true,
              //     modName: "add-pt",
              //     isPT: true,
              //   }))
              // }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from={"centralised-plans"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={centralisedPlansLoading}
              selectedTab={selectedTab}
              searchPlaceHolder={"Search by plan name"}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CentralisedTabs
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setSelectedTab={setSelectedTab}
              setModValues={setModValues}
              userInfoData={userInfoData}
              callFunction={() => {
                getAllCentralisedPlans(filters);
                getAllAddonDrafts(filters);
              }}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default CentralisedPlans;
